import { useTranslation } from "react-i18next"
import { Input } from '@chakra-ui/react'
import { colors } from "../../../utilities/colors"

export default function FinancialCompanyInput({ value, onChange }) {
  const { t } = useTranslation()

  return (
    <Input
      value={value}
      onChange={(event) => onChange(event.target.value)}
      placeholder={t("Financial Company")}
      data-testid="financial-company-input"
      className="px-4 w-48 ml-1 bg-grey-900 rounded"
      borderWidth={2}
      borderColor={colors.grey700}
      _focus={{ borderColor: colors.grey300, ringColor: "transparent" }}
    />
  )
}
